module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-room"
  }, [_c('checklist', {
    attrs: {
      "required": true,
      "options": _vm.list,
      "max": 1
    },
    on: {
      "on-change": function($event) {
        _vm.selectChange()
      }
    },
    model: {
      value: (_vm.checkedVal),
      callback: function($$v) {
        _vm.checkedVal = $$v
      },
      expression: "checkedVal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2e865c4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/wifi/SelectRoom.vue
// module id = 925
// module chunks = 1